<template>
	<div>
		<div class="public-table-but__left">
			<div class="item">
				<!-- <em>筛选：</em> -->
				<div class="item-wp">
					<template v-if="searchShow">
						<div class="item-son">
							<el-input
								v-model="listParams.searchKey"
								placeholder="搜索关键词"
								size="medium"
								clearable
								@keyup.enter.native="queryTableData"
							></el-input>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.status"
								size="medium"
								clearable
								placeholder="请选择"
								style="width: 100px"
							>
								<el-option label="正常" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-button size="medium" type="primary" @click="queryTableData"
								>查询 <i class="el-icon-search"></i>
							</el-button>
						</div>
					</template>

					<div class="item-son" v-if="addShow">
						<el-button size="medium" type="primary" @click="handleClick('add')"
							>新增 <img src="@assets/images/add-icon.png" alt="" />
						</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="public-table-data">
			<el-table
				ref="multipleTable"
				size="medium"
				:data="tableData"
				border
				style="width: 100%"
				row-key="categoryId"
				v-loading="loading"
				:tree-props="{ children: 'examCategoryVos' }"
			>
				<el-table-column type="index" label="序号" width="80" align="center">
				</el-table-column>
				<el-table-column prop="name" label="名称" align="center">
				</el-table-column>
				<el-table-column prop="descr" label="说明" width="150" align="center">
				</el-table-column>
				<el-table-column prop="seq" label="排序" align="center">
				</el-table-column>
				<el-table-column label="状态" align="center">
					<template slot-scope="scope">
						<el-switch
							:disabled="statusShow"
							v-model="scope.row.status"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitch(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button
							v-if="editShow"
							size="mini"
							@click="handleClick('edit', scope.row)"
							type="warning"
							plain
							>编辑</el-button
						>
						<el-button
							v-if="deleteShow"
							size="mini"
							@click="handleDelete(scope.row)"
							type="primary"
							plain
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 编辑弹框 -->
		<el-dialog
			title="添加/编辑测评分类"
			:visible.sync="dialogVisible"
			width="460px"
			class="public-dialog"
			:close-on-click-modal="false"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						v-if="this.clickType != 'add'"
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick(params)"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="上一级">
						<el-select
							v-model="dictDataSelect"
							placeholder="请选择"
							ref="selectReport"
							clearable
							style="width: 100%"
						>
							<el-option
								:value="params.categoryId"
								:label="params.categoryId"
								style="height: auto"
							>
								<el-tree
									:data="selectData"
									node-key="categoryId"
									ref="categoryTree"
									:props="treeProps"
									:render-after-expand="true"
									:expand-on-click-node="false"
									@node-click="handleNodeClick"
								></el-tree>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item
						class="item"
						label="名称"
						prop="name"
						style="width: 100%"
					>
						<el-input
							placeholder="请填写评测分类名称"
							v-model="params.name"
						></el-input>
					</el-form-item>

					<el-form-item label="说明">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请填写说明"
							v-model="params.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item
						class="item"
						label="序号"
						prop="seq"
						style="width: 100%"
					>
						<el-input type="number" v-model="params.seq"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { isEmpty } from "../../utils/tools";
export default {
	data() {
		return {
			clickType: "",
			listParams: {
				tree: true,
				paging: false,
			},
			params: {},
			dictDataSelect: "",
			tableData: [],
			selectData: [],
			languageList: [],
			languageCode: "",
			dialogVisible: false,
			loading: false,
			treeProps: {
				//配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
				value: "parentId",
				children: "examCategoryVos",
				label: "name",
			},
			rules: {
				name: [
					{ required: true, message: "请填写评测分类名称", trigger: "blur" },
				],
				descr: [{ required: true, message: "请填写说明", trigger: "blur" }],
				seq: [
					{
						// required: true,
						message: "请填写序号",
						trigger: "blur",
					},
				],
			},
			addShow: false,
			deleteShow: false,
			editShow: false,
			statusShow: true,
			searchShow: false,
		};
	},
	created() {
		this.queryTableData();
		this.getPermissionButtonList();
		this.getLanguageList();
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
			}
		},
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			// if (e == "question") {
			// 	this.getDetail();
			// }
			this.handleClick("edit", e);
		},
		getPermissionButtonList() {
			let PermissionButtonList = window.sessionStorage.getItem(
				"TaotanPermissionButton"
			);
			let arr = JSON.parse(PermissionButtonList);
			if (arr.length) {
				arr.map((item) => {
					if (item.code == "exam:category:query") {
						this.searchShow = true;
					}
					if (item.code == "exam:category:add") {
						this.addShow = true;
					}
					if (item.code == "exam:category:delete") {
						this.deleteShow = true;
					}
					if (item.code == "exam:category:edit") {
						this.editShow = true;
					}
					if (item.code == "exam:category:status") {
						this.statusShow = false;
					}
				});
			}
		},
		/**
		 * 获取列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("/exam/category/list", {
				params: this.listParams,
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data == undefined) {
				this.tableData = [];
				return;
			}
			resData.data.sort(function (a, b) {
				return b.seq - a.seq;
			});
			resData.data.forEach((element) => {
				if (element.examCategoryVos) {
					element.examCategoryVos.sort(function (a, b) {
						return b.seq - a.seq;
					});
				}
			});
			this.tableData = resData.data;
			this.selectData = resData.data;
		},
		async changeSwitch(b) {
			const { data: resData } = await this.$put(
				`/exam/category/info/status/${b.categoryId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
		},

		handleNodeClick: function (node) {
			this.dictDataSelect = node.name;
			this.params.parentId = node.categoryId;
			this.$refs.selectReport.blur();
		},

		/**
		 * 表格按钮点击
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			this.dialogVisible = true;
			if (type == "edit") {
				//编辑

				const { data } = await this.$get(
					"/exam/category/info/" + row.categoryId,
					{
						headers: {
							"Language-Code": this.languageCode,
						},
					}
				);
				if (data.result != 200) return;

				this.$nextTick(() => {
					//回显上一级
					let temp = this.$refs.categoryTree.getNode(data.data.categoryId)
						.parent.data.name;
					this.dictDataSelect = temp;
				});
				this.isDisabled = true;
				this.params = data.data;
			}
			if (type == "add") {
				this.params = {};
			}
		},

		/**
		 * 编辑/新增
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (
					isEmpty(this.dictDataSelect) &&
					this.clickType == "edit" &&
					this.params.parentId != 0
				) {
					this.$message.warning("请选择上一级（必选）");
					return;
				}
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					if (this.clickType == "add") {
						const { data: resData } = await this.$post(
							"/exam/category/info",
							this.params,
							{
								headers: {
									isLoading: true,
								},
							}
						);

						if (resData.result != 200) return;

						this.queryTableData();

						this.dialogVisible = false;

						this.$message.success("添加成功!");
						this.params = {};
					} else {
						const { data: resData } = await this.$put(
							"/exam/category/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);

						if (resData.result != 200) return;

						this.queryTableData();

						this.dialogVisible = false;

						this.$message.success("修改成功!");
					}
				});
			});
		},

		/**
		 * 删除
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/exam/category/info/${row.categoryId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();

				this.$message.success("删除成功!");
			});
		},
	},
};
</script>
